"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactTransitionGroup = require("react-transition-group");
var _Spinner = _interopRequireDefault(require("./Spinner"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var OverlaySpinner = function OverlaySpinner(_ref) {
  var animationTimeout = _ref.animationTimeout,
    description = _ref.description,
    show = _ref.show,
    text = _ref.text;
  return /*#__PURE__*/_react["default"].createElement(_reactTransitionGroup.TransitionGroup, {
    className: "overlay"
  }, show && /*#__PURE__*/_react["default"].createElement(_reactTransitionGroup.CSSTransition, {
    classNames: "overlay",
    className: "overlay-spinner",
    timeout: {
      enter: animationTimeout,
      exit: animationTimeout
    }
  }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "overlay-spinner__text-container"
  }, /*#__PURE__*/_react["default"].createElement("p", {
    className: "overlay-spinner__text"
  }, text), description && /*#__PURE__*/_react["default"].createElement("p", {
    className: "overlay-spinner__description"
  }, description)), /*#__PURE__*/_react["default"].createElement("div", {
    className: "overlay-spinner__options"
  }, /*#__PURE__*/_react["default"].createElement(_Spinner["default"], null)))));
};
OverlaySpinner.propTypes = {
  animationTimeout: _propTypes["default"].number,
  description: _propTypes["default"].string,
  show: _propTypes["default"].bool,
  text: _propTypes["default"].string
};
OverlaySpinner.defaultProps = {
  animationTimeout: 500,
  description: '',
  show: false,
  text: 'Submitting...'
};
var _default = exports["default"] = OverlaySpinner;